import { Controller } from "@hotwired/stimulus";
import { sendSuccessNotification, sendFailureNotification } from "shared/toast_notifications";

// Connects to data-controller="table--delete-button"
export default class extends Controller {

    delete(event) {
        // If we don't have any params, do nothing and return
        if (!event.params || Object.keys(event.params).length === 0) {
            return;
        }

        // Grab the id and name
        const partId = event.params.id;
        const partName = event.params.name;

        // If the ID is empty, do nothing and return
        if (_.isEmpty(partId)) {
            return;
        }

        // Issue the delete request
        this._deletePart(partId, partName);
    }

    _deletePart(partId, partName) {
        return $.ajax({
            url: '/api/device_types/part/delete',
            type: 'DELETE',
            dataType: 'json',
            data: {
                id: partId,
                name: partName
            }, success: () => {
                // Show success notification
                sendSuccessNotification(`Successfully deleted part: ${partName}`);
                
                // Remove the row from the table
                this._removeTableRow();
            }, error: (jqXHR, textStatus, errorThrown) => {
                // Show failure notification
                sendFailureNotification(`Failed to delete part: ${partName}`);
            }
        });
    }

    _removeTableRow() {
        // Find the closest table row and remove it with a fade effect
        const row = this.element.closest('tr');
        if (row) {
            $(row).fadeOut(300, function() {
                $(this).remove();
            });
        }
    }
}